// Small utility to remove empty paragraph nodes inside the
// former-trust disclosure to guard against editor-inserted <p>&nbsp;</p>

function isEmptyParagraph(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
    if (node.tagName.toLowerCase() !== "p") return false;
    // Get the text content trimmed and also check for non-breaking spaces
    const text = node.textContent.replace(/\u00A0/g, "").trim();
    if (text.length > 0) return false;
    // Also treat paragraphs that only contain a single <br> as empty
    if (node.childNodes.length === 1 && node.firstChild.nodeName === "BR")
        return true;
    return true;
}

function cleanFormerTrustDisclosures(root = document) {
    const selectors =
        ".trusts-overview__disclosure--former-trust .notice__content p";
    const paras = Array.from(root.querySelectorAll(selectors));
    paras.forEach((p) => {
        // If paragraph contains only whitespace / NBSP / single <br>, remove it
        if (isEmptyParagraph(p)) {
            p.parentNode && p.parentNode.removeChild(p);
        }
    });
}

// Run on DOMContentLoaded; also expose a small function for tests
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () =>
        cleanFormerTrustDisclosures()
    );
} else {
    cleanFormerTrustDisclosures();
}

export { cleanFormerTrustDisclosures };
